import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";

class EditarCirugia extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
        this.consultarTodo();
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  };

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "cirugias/datosCirugia",
        { empresaId: this.props.empresaId, cirugiaId: this.props.cirugiaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
            this.formRef.current.setFieldsValue(res.data.cirugia)
        } else {
            message.error("No se encontro informacion");
        }
      });
  }

  onFinish(values) {
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "cirugias/editarCirugia",
          {
            ...values,
            empresaId: this.props.empresaId,
            cirugiaId: this.props.cirugiaId 
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Cirugia editada exitosamente");
            this.cerrarEditarCirugia();
          } else if (res.data.success === 1) {
            message.error("No se pudo editar la cirugia");
          } else {
            message.error("Sucedió un error y no se pudo editar la cirugia");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre de la cirugia");
    }
  }
  

  cerrarEditarCirugia = () => {
    this.props.cerrarEditarCirugia();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Cirugia"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarEditarCirugia.bind(this)}
      >
        <Form
          ref={this.formRef}
          name="modalEditarDoctor"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="codigo"
            label="Número de Cirugia"
            required
            margin
          >
            <InputItem disabled placeholder="Ingresa el número de la cirugia" />
          </FormItem>

          <FormItem
            name="nombre"
            label="Nombre de la cirugia"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre de la cirugia" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarCirugia);
